/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import BasicContainer from '../../components/BasicContainer';
import { currencies } from '../../utilities/constants';
import { formatNumber } from '../../utilities/formatHelpers';
import { dynamicAssets } from '../../utilities/helpers';

const LoyaltyProgram = ({
  label = null,
  subLabel = null,
  onClick,
  disabled = null,
  className = '',
  image,
  rightImage = null,
  cashbackData = null,
  onInfoIconMouseEnter = null,
  onInfoIconMouseLeave = null,
}) => {
  const { t: translate } = useTranslation();
  const currency = currencies[cashbackData?.cashback_currency?.toUpperCase()];
  const availableCashbackRaward = formatNumber(
    cashbackData?.total_reward_amount * currency.conversion,
    currency?.decimal
  );

  return (
    <BasicContainer
      onClick={onClick}
      className={`bg-lighter ${
        subLabel ? 'py-3' : ''
      } cursor-pointer hover-container position-relative bg-lighter ${
        disabled ? 'disabled-block' : ''
      }
      ${isMobile && 'mb-2'}
      ${className}`}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <div
          className="bg-light p-3 d-flex justify-content-center"
          style={{ borderRadius: '124px' }}>
          <img
            alt={image}
            src={dynamicAssets(`./assets/images/${image}.svg`)}
            style={{ width: '1.5rem', height: '1.5rem' }}
          />
        </div>

        <div role="presentation" className="col-9 ms-1">
          <p>
            <b>{label || translate('manage_your_accounts_label')}</b>
          </p>
          {cashbackData && (
            <p className="text-shadow text-f6">
              <Trans
                i18nKey="loyalty_program_available_cashback_currency_sublabel"
                values={{
                  amount: availableCashbackRaward,
                  currency: cashbackData.cashback_currency,
                }}
                components={[<span key="amount" className="text-primary" />]}
              />
            </p>
          )}
          {!cashbackData && subLabel && <p className="text-shadow text-f6">{subLabel}</p>}
        </div>

        {!rightImage && (
          <i
            style={{ width: '1rem' }}
            className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
            role="button"
            aria-label={label || translate('manage_your_accounts_label')}
            tabIndex={0}
            onKeyDown={() => {}}
          />
        )}

        {rightImage && (
          <i
            style={{ width: '1rem' }}
            className={`icon ${rightImage} text-shadow text-f4 cursor-pointer d-block text-hover-dimmed`}
            role="button"
            aria-label="info"
            tabIndex={0}
            onMouseEnter={cashbackData ? onInfoIconMouseEnter : null}
            onMouseLeave={cashbackData ? onInfoIconMouseLeave : null}
          />
        )}
      </div>
    </BasicContainer>
  );
};

export default LoyaltyProgram;

LoyaltyProgram.propTypes = {
  onClick: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  subLabel: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  rightImage: PropTypes.string,
  cashbackData: PropTypes.object,
  onInfoIconMouseEnter: PropTypes.func,
  onInfoIconMouseLeave: PropTypes.func,
};
